import dispatcher from '../dispatchers/dispatcher';

export function getArticles(hardRefresh) {
    let articles = JSON.parse(sessionStorage.getItem('articles'));
    if (!articles || hardRefresh) {
        var xhr = new XMLHttpRequest();
        xhr.open('GET', 'http://www.wblocks.com/magAPI/articles/surf', true);
        xhr.onreadystatechange = function () {
            if (xhr.readyState == 4) {
                if (xhr.status === 200) {
                    var data = eval('(' + xhr.response + ')');
                    sessionStorage.setItem('articles', JSON.stringify(data.success.body.articles));
                    dispatcher.dispatch({
                        type: 'GET_ARTICLES',
                        articles: data.success.body.articles
                    });
                } else if (xhr.status === 0) {
                    dispatcher.dispatch({
                        type: 'NO_NETWORK_CONNECTION'
                    });
                }
            }
        }
        xhr.send();
    } else {
        setTimeout(() => {
            dispatcher.dispatch({
                type: 'GET_ARTICLES',
                articles: articles
            });
        }, 20);
    }
}


// WEBPACK FOOTER //
// ./src/actions/MagazineActions.js